import { Card, CardBody } from 'reactstrap';

import Knob from 'src/modules/3rd-party-management/components/Knob';
import { PPWR_READINESS_KNOB_SETTINGS } from 'src/modules/3rd-party-management/constants';

const PPWRReadinessScore = ({
    t,
    readinessScore = 0,
    reviewItems = 0,
}) => (
    <Card className="h-100 mb-0 shadow-sm">
        <CardBody className="h-100">
            <div className="d-flex align-items-center justify-content-between gap-3 h-100">
                <div className="flex-grow-1 overflow-hidden">
                    <p className="ppwr-summary-widget__title mb-4">
                        {t('PPWR Readiness Score')}
                    </p>
                    <div className="d-flex align-items-center gap-1">
                        <i className="ri-alert-line ppwr-summary-widget__warning-icon flex-shrink-0" />
                        <span className="ppwr-summary-widget__warning-text">
                            {t('{{count}} Packaging Items Require Review', {
                                count: reviewItems,
                            })}
                        </span>
                    </div>
                </div>

                <div className="flex-shrink-0 d-flex align-items-center justify-content-center">
                    <Knob
                        value={Number(readinessScore) || 0}
                        readOnly={true}
                        {...PPWR_READINESS_KNOB_SETTINGS}
                    />
                </div>
            </div>
        </CardBody>
    </Card>
);

export default PPWRReadinessScore;
